import React from "react";
import { connect } from "react-redux";
import { getSingleServiceAccount } from "../../queries/serviceAccount/serviceAccountQuery";
import language from "../../language";
import { Table } from "../Table";

class ServiceAccount extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading) => {
    const { defaultLanguage, serviceAccountId } = this.props;
    try {
      this.setState({ isLoading });

      const data = await getSingleServiceAccount(defaultLanguage, {
        serviceAccountId,
      });

      this.setState({
        isLoading: false,
        data: typeof data === "object" && data.clientId ? [data] : [],
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].client_id,
        key: "clientId",
        isNormalText: true,
      },
      {
        title: language[this.props.defaultLanguage].client_secret,
        key: "clientSecret",
        isNormalText: true,
      },
    ];

    return headers;
  }

  returnTableIntegrationServicesHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].service_code,
        key: "serviceCode",
      },
      {
        title: language[this.props.defaultLanguage].title,
        key: "integrationProfile.title",
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "integrationProfile.integrationType",
      },
    ];

    return headers;
  }

  render() {
    return (
      <div className="card-body">
        <Table
          data={this.state.data}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          headers={this.returnTableHeaders()}
        />
        <div>
          <div>
            <h3>Integration Services</h3>
          </div>
          {this.state.data.map((item) => {
            return (
              <>
                {item?.integrationProfiles?.length > 0 && (
                  <Table
                    data={item?.integrationProfiles}
                    headers={this.returnTableIntegrationServicesHeaders()}
                  />
                )}
              </>
            );
          })}
        </div>

        {/* {this.state.data?.integrationProfiles?.map((el) => {
          return <div className="list-group-item">
            <span>{el.integrationProfile.title}</span>
            <span>{el.integrationProfile.title}</span>
            <span>{el.integrationProfile.integrationType}</span>
          </div>
        })} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ServiceAccount);
